/**
 * Helper functions for date formatting in the Events components
 */

/**
 * Returns the ordinal suffix for a given day (1st, 2nd, 3rd, 4th, etc.)
 * @param {number} day - The day of the month
 * @returns {string} - The ordinal suffix
 */
export const getOrdinalSuffix = (day) => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1: return 'st';
    case 2: return 'nd';
    case 3: return 'rd';
    default: return 'th';
  }
};

/**
 * Formats a date range from start date to end date
 * @param {string} startDate - The start date string
 * @param {string} endDate - The end date string
 * @returns {string} - Formatted date range string
 */
export const formatDateRange = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  
  const startMonth = start.toLocaleString('default', { month: 'long' });
  const endMonth = end.toLocaleString('default', { month: 'long' });
  const startDay = start.getDate();
  const endDay = end.getDate();
  const year = start.getFullYear();

  if (startMonth === endMonth) {
    return `${startMonth} ${startDay} - ${endDay}, ${year}`;
  } else {
    return `${startMonth} ${startDay} - ${endMonth} ${endDay}, ${year}`;
  }
};

/**
 * Formats a date string into an object with month, day, and ordinal suffix
 * @param {string} dateString - The date string to format
 * @returns {Object} - Object containing formatted month, day, and ordinal suffix
 */
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return {
    month: date.toLocaleString('default', { month: 'short' }).toUpperCase(),
    day: date.getDate(),
    ordinal: getOrdinalSuffix(date.getDate())
  };
}; 